import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { ImageCropperComponent, CropperSettings, Bounds } from 'ng2-img-cropper';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { Router, ActivatedRoute } from '@angular/router';
import * as $ from 'jquery';

@Component(({
  selector: 'app-imageupload',
  templateUrl: './imageupload.component.html',
  styleUrls: ['./imageupload.component.css'],
  directives: [ImageCropperComponent]
}) as any)
export class ImageUploadComponent implements OnInit {
  fileToUpload: File;
  fileName:string;
  cropperSettings: CropperSettings;
  employeeId: string;
  data: any;
  @ViewChild('cropper', undefined) cropper: ImageCropperComponent;

  constructor(
    @Inject(MAT_DIALOG_DATA) public dataDialog: any,
    public dialog: MatDialogRef<ImageUploadComponent>,
    private route: ActivatedRoute,
    private router: Router) {

    this.cropperSettings = new CropperSettings();
    this.cropperSettings.width = 200;
    this.cropperSettings.height = 200;

    this.cropperSettings.croppedWidth = 150;
    this.cropperSettings.croppedHeight = 150;

    this.cropperSettings.canvasWidth = 350;
    this.cropperSettings.canvasHeight = 350;

    this.cropperSettings.minWidth = 100;
    this.cropperSettings.minHeight = 100;

    this.cropperSettings.rounded = false;
    this.cropperSettings.noFileInput = true;

    this.cropperSettings.cropperDrawSettings.strokeColor = 'rgba(153,153,153,1)';
    this.cropperSettings.cropperDrawSettings.strokeWidth = 4;

    this.data = {};
  }

  fileChangeListener(event) {
    var image: any = new Image();
    var file: File = event.target.files[0];
    var filesize = file.size;
    var filetype = file.type;
    if (filesize > 5000000) {
      $("#image-error").text("Không được tải ảnh lớn hơn 5mb.");
      return;
    } else if (filetype !== 'image/png' && filetype !== 'image/jpg' && filetype !== 'image/jpeg') {
      $("#image-error").text("Chỉ được tải ảnh có định dạng jpg, jpeg hoặc png.");
      return;
    } else {
      this.fileToUpload = file;
      this.fileName = file.name;
      $("#image-error").text("");

      var myReader: FileReader = new FileReader();
      var that = this;
      myReader.onloadend = (loadEvent: any) => {
        image.src = loadEvent.target.result;
        that.cropper.setImage(image);
      };

      myReader.readAsDataURL(file);
    }
  }

  chooseImage() {
    $("#custom-input").trigger("click");
  }

  cropped(bounds: Bounds) {
  }

  saveImage() {
    this.dialog.close(this.data);
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/imageupload/imageupload.component.ts